const QuanList = () => import('@/view/quan/index.vue')
const QuanDetail = () => import('@/view/quan/detail.vue')
const QuanHistory = () => import('@/view/quan/history.vue')
export default [
  
  {
    path: '/quan/list',
    name: 'quanList',
    component: QuanList,
    meta: { pageName: 'page_coupon_detail' }
  },
  {
    path: '/quan/detail',
    name: 'quanDetail',
    component: QuanDetail,
    meta: { pageName: 'page_coupon' }
  }, {
    path: '/quan/detail-share-cash',
    name: 'quanDetailShareCash',
    component: () => import('@/view/quan/detail-share-cash.vue'),
    meta: { pageName: 'page_coupon_share_cash' }
  },
  {
    path: '/quan/history',
    name: 'quanHistory',
    component: QuanHistory,
    meta: { pageName: 'page_coupon_history' }
  },
  // 新优惠券列表 V3.0
  {
    path: '/coupon/list',
    name: 'couponList',
    component: () => import('@/view/quan/list.vue'),
    meta: { pageName: 'page_message_list' }
  },
  {
    path: '/coupon/detail-v3-cash',
    name: 'couponDetailV3Cash',
    component: () => import('@/view/quan/detail-v3-cash.vue'),
    meta: { pageName: 'page-message-detail-v3-cash' }
  },
  {
    path: '/coupon/detail-v3-interest-free',
    name: 'couponDetailV3Free',
    component: () => import('@/view/quan/detail-v3-interest-free.vue'),
    meta: { pageName: 'page-message-detail-v3-interest-free' }
  },  
  {
    path: '/coupon/detail-v3-credit-coupon',
    name: 'couponDetailV3Credit',
    component: () => import('@/view/quan/detail-v3-credit-coupon.vue'),
    meta: { pageName: 'page-message-detail-v3-credit-coupon' }
  }
]